module.exports = __webpack_public_path__ + "img/9788932036014.ce8459d6.jpg";